export const FETCH_UNREAD_COUNTS_BY_TYPE = 'CHAT/CONVERSATIONS/UNREAD/BY_TYPE/FETCH_REQUEST';
export const FETCH_UNREAD_COUNTS_BY_TYPE_SUCCESS = 'CHAT/CONVERSATIONS/UNREAD/BY_TYPE/FETCH_SUCCESS';
export const FETCH_UNREAD_COUNTS_BY_TYPE_FAILURE = 'CHAT/CONVERSATIONS/UNREAD/BY_TYPE/FETCH_FAILURE';

export const GENERIC_FETCH_CONVERSATIONS = 'CHAT/CONVERSATIONS/GENERIC_FETCH_REQUEST';

export const FETCH_CONVERSATIONS = 'CHAT/CONVERSATIONS/FETCH_REQUEST';
export const FETCH_CONVERSATIONS_SUCCESS = 'CHAT/CONVERSATIONS/FETCH_SUCCESS';
export const FETCH_CONVERSATIONS_FAILURE = 'CHAT/CONVERSATIONS/FETCH_FAILURE';

export const CLEAR_CONVERSATIONS = 'CHAT/CONVERSATIONS/CLEAR';
export const CLEAR_CUSTOMER_CONVERSATIONS = 'CHAT/CONVERSATIONS/CUSTOMER/CLEAR_CONVERSATIONS';
export const CLEAR_INTERNAL_CONVERSATIONS = 'CHAT/CONVERSATIONS/INTERNAL/CLEAR_CONVERSATIONS';

export const FETCH_CONVERSATION = 'CHAT/CONVERSATION/FETCH_REQUEST';
export const FETCH_CONVERSATION_SUCCESS = 'CHAT/CONVERSATION/FETCH_SUCCESS';
export const FETCH_CONVERSATION_FAILURE = 'CHAT/CONVERSATION/FETCH_FAILURE';

export const POST_CONVERSATION = 'CHAT/CONVERSATION/POST_REQUEST';
export const POST_CONVERSATION_SUCCESS = 'CHAT/CONVERSATION/POST_SUCCESS';

export const FETCH_MESSAGES = 'CHAT/MESSAGES/FETCH_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'CHAT/MESSAGES/FETCH_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'CHAT/MESSAGES/FETCH_FAILURE';

export const POST_MESSAGE = 'CHAT/MESSAGES/POST_REQUEST';
export const POST_MESSAGE_SUCCESS = 'CHAT/MESSAGES/POST_SUCCESS';
export const POST_MESSAGE_FAILURE = 'CHAT/MESSAGES/POST_FAILURE';

export const OPEN_CREATE_CONVERSATION_MODAL = 'CHAT/CONVERSATION/MODAL/OPEN_CREATE_CONVERSATION_MODAL';
export const CLOSE_CREATE_CONVERSATION_MODAL = 'CHAT/CONVERSATION/MODAL/CLOSE_CREATE_CONVERSATION_MODAL';

export const SET_ACTIVE_TABS = 'CHAT/UI/SET_TABS';

export const SET_INIT_CHAT = 'CHAT/INITIALIZE/SET';
export const CHAT_IS_READY = 'CHAT/INITIALIZE/READY';

export const MARK_ALL_AS_READ = 'CHAT/DASHBOARD/CONVERSATION/MARK_ALL_AS_READ_REQUEST';
export const MARK_ALL_AS_READ_SUCCESS = 'CHAT/DASHBOARD/CONVERSATION/MARK_ALL_AS_READ_SUCCESS';

export const PATCH_CONVERSATION_STATUS = 'CHAT/CONVERSATION/STATUS/PATCH_REQUEST';
export const PATCH_CONVERSATION_STATUS_SUCCESS = 'CHAT/CONVERSATION/STATUS/PATCH_SUCCESS';
export const PATCH_CONVERSATION_STATUS_FAILURE = 'CHAT/CONVERSATION/STATUS/PATCH_FAILURE';

export const SET_CHAT_FILTER = 'CHAT/DASHBOARD/SET/FILTER';
export const SET_CHAT_FILTERS = 'CHAT/DASHBOARD/SET/FILTERS';
export const CLEAR_CHAT_FILTER = 'CHAT/DASHBOARD/CLEAR/FILTERS';
export const REMOVE_CHAT_FILTER = 'CHAT/DASHBOARD/REMOVE/FILTER';

export const PERSISTED_CHAT = [
  SET_CHAT_FILTER,
  SET_CHAT_FILTERS,
  CLEAR_CHAT_FILTER,
  REMOVE_CHAT_FILTER,
];

export const CUSTOMER_HAS_VALID_CONVERSATION = 'CHAT/CUSTOMER/CONTEXT/VALID/REQUEST';
export const CUSTOMER_HAS_VALID_CONVERSATION_SUCCESS = 'CHAT/CUSTOMER/CONTEXT/VALID/SUCCESS';
export const CUSTOMER_HAS_VALID_CONVERSATION_FAILURE = 'CHAT/CUSTOMER/CONTEXT/VALID/FAILURE';

export const FETCH_CONVERSATION_ATTACHMENTS = 'CHAT/CONVERSATION/MEDIA/FETCH_REQUEST';
export const FETCH_CONVERSATION_ATTACHMENTS_SUCCESS = 'CHAT/CONVERSATION/MEDIA/FETCH_SUCCESS';

export const UNMOUNT_CONVERSATION_ATTACHMENTS_PANE = 'CHAT/CONVERSATION/MEDIA/UNMOUNT_PANE';

export const RECEIVE_MESSAGE_FROM_SOCKET = 'CHAT/CONVERSATION/MESSAGE/UPDATE_FROM_SOCKET';

export const FETCH_CONVERSATION_CONTEXT = 'CHAT/CONVERSATION/CONTEXT/FETCH_REQUEST';
export const FETCH_CONVERSATION_CONTEXT_SUCCESS = 'CHAT/CONVERSATION/CONTEXT/FETCH_SUCCESS';
export const SET_CONTEXT_ID = 'CHAT/CONVERSATION/CONTEXT/SET_ID';

export const FETCH_CONVERSATION_HISTORY = 'CHAT/CONVERSATION/HISTORY/FETCH_REQUEST';
export const FETCH_CONVERSATION_HISTORY_SUCCESS = 'CHAT/CONVERSATION/HISTORY/FETCH_SUCCESS';

export const SET_HISTORY_ID = 'CHAT/CONVERSATION/HISTORY/SET_ID';

export const OPEN_MEDIA_DRAWER = 'CHAT/CONVERSATION/MEDIA_DRAWER/OPEN';
export const CLOSE_MEDIA_DRAWER = 'CHAT/CONVERSATION/MEDIA_DRAWER/CLOSE';

export const PREPEND_CONVERSATION_IN_LIST = 'CHAT/DASHBOARD/CONVERSATION/PREPEND_IN_LIST';
